import { startOfYear } from 'date-fns';
import {create} from "zustand";

const today = new Date();

type DashboardFilterType = {
    filter: {
        startDate?: Date | null;
        endDate?: Date | null;
        apartmentId?: {
            id: string;
            name?: string;
        }[];
    },
    setFilter: ( filter: Partial<DashboardFilterType['filter']> ) => void;
    resetFilter: () => void;
};

const defaultState: DashboardFilterType['filter'] = {
    startDate: startOfYear(today),
    endDate: today,
    apartmentId: [],   
};

export const useDashboardFilter = create<DashboardFilterType>((set) => ({
    filter: {...defaultState },
    setFilter: (newFilter) => {
        set((state) => ({
            filter: {
                ...state.filter,
                ...newFilter,
            },
        }));
    },
    resetFilter: () => {
        set({ 
            filter: {...defaultState },
        });
    },
}));